import { router, usePage } from '@inertiajs/react';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import MuiAvatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import MuiListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import MenuItem from '@mui/material/MenuItem';
import Select, { selectClasses } from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import SitemarkIcon from '../pages/Landing/components/SitemarkIcon';

const Avatar = styled(MuiAvatar)(({ theme }) => ({
  width: 28,
  height: 28,
  backgroundColor: (theme.vars || theme).palette.background.paper,
  color: (theme.vars || theme).palette.text.secondary,
  border: `1px solid ${(theme.vars || theme).palette.divider}`,
}));

const ListItemAvatar = styled(MuiListItemAvatar)({
  minWidth: 0,
  marginRight: 12,
});

const GodModeMenu = ({ setCompany, setCompanyName }) => {
  const { props } = usePage();

  return (
    <>
      <Divider sx={{ mx: -1 }} />
      <ListSubheader sx={{ pt: 0 }}>Organizações</ListSubheader>
      {
        props.current.organizations.map(([name, id]) => (
          <MenuItem key={id} value={id} onClick={() => {
            setCompany(id);
            setCompanyName(name);
            router.post(`/organizations/change`, {
              organization: { id },
            });
          }}>
            <ListItemAvatar>
              <Avatar alt={name}>
                <SitemarkIcon sx={{ fontSize: '1rem' }} />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={name} secondary={name} />
          </MenuItem>
        ))
      }
      <Divider sx={{ mx: -1 }} />
      <MenuItem value={null} onClick={() => router.get('/organizations/new')}>
        <ListItemIcon>
          <AddRoundedIcon />
        </ListItemIcon>
        <ListItemText primary="Adicionar Organização" secondary="Adicionar Organização" />
      </MenuItem>
    </>
  );
};

export default function SelectContent() {
  const { props } = usePage();
  const [company, setCompany] = React.useState(props.current.organization.id);
  const [companyName, setCompanyName] = React.useState(props.current.organization.name);

  if (!props.current.roles.includes('god_mode')) {
    return (
      <Box width={215}>
        <MenuItem value={company}>
          <ListItemAvatar>
            <Avatar alt={companyName}>
              <SitemarkIcon sx={{ fontSize: '1rem' }} />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary={companyName} secondary={companyName} />
        </MenuItem>
      </Box>
    );
  }

  return (
    <Select
      labelId="organization-select"
      id="organization-simple-select"
      value={company}
      inputProps={{ 'aria-label': 'Selecione uma organização' }}
      fullWidth
      sx={{
        maxHeight: 56,
        width: 215,
        '&.MuiList-root': {
          p: '8px',
        },
        [`& .${selectClasses.select}`]: {
          display: 'flex',
          alignItems: 'center',
          gap: '2px',
          pl: 1,
        },
      }}
    >
      <ListSubheader sx={{ pt: 0 }}>Organização atual</ListSubheader>
      <MenuItem value={company}>
        <ListItemAvatar>
          <Avatar alt={companyName}>
            <SitemarkIcon sx={{ fontSize: '1rem' }} />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={companyName} secondary={'Enterprise'} />
      </MenuItem>
      <GodModeMenu setCompany={setCompany} setCompanyName={setCompanyName} />
    </Select>
  );
}
